import script from "./GridCellHeaderAndValue.vue?vue&type=script&setup=true&lang=js"
export * from "./GridCellHeaderAndValue.vue?vue&type=script&setup=true&lang=js"

import "./GridCellHeaderAndValue.vue?vue&type=style&index=0&id=a1a3bdc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1a3bdc6"]])

export default __exports__